import React from "react";
import styled from "styled-components";

const DetailsBodyWrapper = styled.section`
  position: relative;
  background-color: #f0f0f0;
  overflow: hidden;
  padding: 15px;
  border-right: 1px solid #666;
  border-bottom: 1px solid #666;
  margin-bottom: 10px;
  img {
    display: block;
  }
  .body-comment {
    font-size: 16px;
    white-space: pre-wrap;
    margin-bottom: 25px;
  }
  ${({ edit }) =>
    edit &&
    `
    padding-right: 44px;
  `}
`;

const DetailsBody = ({ edit, children }) => <DetailsBodyWrapper edit={edit}>{children}</DetailsBodyWrapper>;

export default DetailsBody;
